"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.reducer = reducer;
exports.selectEntityID = exports.ACTIONS = void 0;

var _ = require(".");

var selectedEntityID = null;
var ACTIONS = {
  SELECT_ENTITY_ID: new _.Action('SELECT_ENTITY_ID')
};
exports.ACTIONS = ACTIONS;

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedEntityID;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case ACTIONS.SELECT_ENTITY_ID.main:
      {
        selectedEntityID = action.payload.entityID;
        return selectedEntityID;
      }

    default:
      return state;
  }
}

var selectEntityID = function selectEntityID(entityID) {
  return {
    type: ACTIONS.SELECT_ENTITY_ID.main,
    payload: {
      entityID: entityID
    }
  };
};

exports.selectEntityID = selectEntityID;